import { Component, Input } from '@angular/core';
import { ApiKeyResponse } from '../../models/responses/api-key-response';
import { UserService } from '../../services/user.service';
import { NgFor, NgIf } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserResponse } from '../../models/responses/user-response';
import { resetUserInLocalStorage } from '../../utilities/user-utils';

@Component({
  selector: 'app-api-key',
  standalone: true,
  imports: [
    NgFor,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatIcon,
    MatButtonModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './api-key.component.html',
  styleUrl: './api-key.component.scss'
})
export class ApiKeyComponent {

  @Input() connectedUser!: UserResponse;
  isLoading = false;

  constructor(private userService: UserService, private clipBoard: Clipboard) { }

  ngOnInit() {
  }

  copyKeyToClipboard(key: ApiKeyResponse) {
    this.clipBoard.copy(key.key);
  }

  onAddApiKey() {
    this.isLoading = true;
    this.userService.createApiKey().subscribe({
      next: (data) => {
        this.connectedUser.apiKeys = data;
        resetUserInLocalStorage(this.connectedUser);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        alert("Server error, contact admin")
      }
    })
  }

  onDeleteApiKey(id: number) {
    this.isLoading = true;
    this.userService.deleteApiKey(id).subscribe({
      next: (data) => {
        this.connectedUser.apiKeys = data;
        resetUserInLocalStorage(this.connectedUser);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        alert("Server error, contact admin")
      }
    })
  }
}

